import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import SaveIcon from '@material-ui/icons/Save';
import classNames from 'classnames';
import {config, settings} from '../../config/config';
import axios from 'axios';
import Alert from '../alert';
import Loader from '../loader';

const styles = theme => ({
  appBar: {
    position: 'relative'
  },
  icon: {
    marginRight: theme.spacing.unit * 2
  },
  heroUnit: {
    margin: "0 0 15px 0"
  },
  heroContent: {
    maxWidth: 600,
    margin: '0 auto',
    padding: `${theme.spacing.unit * 8}px 0 ${theme.spacing.unit * 6}px`
  },
  heroButtons: {
    marginTop: theme.spacing.unit * 4
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(1100 + theme.spacing.unit * 3 * 2)]: {
      width: 1100,
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  root: {
    flexGrow: 1
  },
  typography: {
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    backgroundColor: theme.palette.background.paper
  },
  paper: {
    padding: theme.spacing.unit * 2,
    color: theme.palette.text.secondary,
    boxShadow: "0px 0px 0px ",
    border: "1px solid #dedede"
  },
  paperDescription: {
    margin: "10px",
    padding: theme.spacing.unit * 2,
    color: theme.palette.text.secondary,
    boxShadow: "0px 0px 0px "
  }
});

class Index extends Component {

  constructor() {
    super();
    this.saveSettings = this.saveSettings.bind(this);
    this.alertHandleClose = this.alertHandleClose.bind(this);
    this.modalHandleClose = this.modalHandleClose.bind(this);
  }

  state = {
    eachFiles: 2500,
    autoDownload: localStorage.getItem("auto") ? true : false
  };

  alertHandleClose() {
    this.setState({isAlertOpen: false});
  }

  modalHandleClose() {
    this.setState({isModalOpen: false});
  }

  async saveSettings() {
    if (this.state.isLoading) {
      return;
    }
    if (this.state.autoDownload) {
      localStorage.setItem("auto", "true");
    } else {
      localStorage.removeItem("auto");
    }
    try {
      this.setState({isLoading: true});
      let parameter = new URLSearchParams();
      parameter.append("per", this.state.eachFiles);
      const response = await axios.post(settings.url + "/save", parameter, config);
      if (response) {
        if (response.data.mes !== "ok") {
          throw response.data.reason;
        }else{
          this.setState({isLoading: false, isModalOpen: true, alertSuccessMessage: "設定を保存しました。"});
        }
      }
    } catch (e) {
      this.setState({isLoading: false, isAlertOpen: true, alertErrorMessage: e});
    }

  }

  handleChangeText = name => event => {
    this.setState({[name]: event.target.value});
  };

  handleChangeChkbox = name => event => {
    this.setState({[name]: event.target.checked});
  };

  render() {
    const {classes} = this.props;

    return (<div>
      <Grid container={true}>
        <Grid item={true} xs={12}>
          <Paper className={classes.paper}>
            <Typography component="h5" variant="h5" className={classes.typography}>
              設定
            </Typography>
            <form className={classes.container} noValidate="noValidate" autoComplete="off">
              <TextField id="outlined-name" label="1ファイルあたりの最大ユーザー数" type="number" className={classes.textField} value={this.state.eachFiles} fullWidth={true} onChange={this.handleChangeText('eachFiles')} margin="normal" variant="outlined"/>
              <Paper className={classes.paperDescription}>
                CSV1つに格納するユーザーIDの数を指定します。<br/>
                最大5000件まで指定できますが、ファイルサイズが大きいと怒られる可能性があるので2500あたりの数値を指定することを推奨します。<br/>
                デフォルトは2500に設定されています。<br/>
                大量のファイルが作成されるのを防ぐため2000件を最小としています。
              </Paper>
              <FormControlLabel style={{
                  userSelect: "none"
                }} control={<Switch
                checked = {
                  this.state.autoDownload
                }
                onChange = {
                  this.handleChangeChkbox('autoDownload')
                }
                value = "autoDownload"
                />} label="自動ダウンロード"/>
              <Paper className={classes.paperDescription}>
                リストを取得後、自動でダウンロードします。<br/>
                この設定はブラウザ依存です。localStorageに対応しており,JavaScriptが有効になっているブラウザが必要です。<br/>
                (Google Chromeで動作確認済み)
              </Paper>
            </form>
            <Grid container={true} style={{
                alignItems: "center"
              }}>
              <Grid item={true}>
                <Button variant="contained" size="large" color="primary" className={classes.button} onClick={this.saveSettings} disabled={this.state.isLoading}>
                  <SaveIcon className={classNames(classes.leftIcon, classes.iconSmall)}/>
                  変更を保存
                </Button>
              </Grid>
              <Grid item={true}>
                <Loader isVisible={this.state.isLoading}/>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
      <Alert open={this.state.isAlertOpen} handleClose={this.alertHandleClose} errorMessage={this.state.alertErrorMessage}/>
      <Alert open={this.state.isModalOpen} handleClose={this.modalHandleClose} errorMessage={this.state.alertSuccessMessage} isSuccess={true}/>
    </div>)
  }
}

Index.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Index);
